import { MatIconRegistry } from '@angular/material/icon';
import { departmentIcons } from './departmentIcons';
import { DomSanitizer } from '@angular/platform-browser';
import { Resident } from '../models/resident.model';
import { Product } from '../models/product.model';
import { CartProduct } from '../models/cart.model';

const loadDepartmentIcons = (
  matIconRegistry: MatIconRegistry,
  domSanitizer: DomSanitizer
) => {
  departmentIcons.forEach(icon => {
    matIconRegistry.addSvgIcon(
      icon.name,
      domSanitizer.bypassSecurityTrustResourceUrl(icon.url)
    );
  });
};

export const loadIcons = (
  matIconRegistry: MatIconRegistry,
  domSanitizer: DomSanitizer
) => {
  matIconRegistry.addSvgIcon(
    `bee-icon`,
    domSanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/bee-icon.svg`)
  );

  matIconRegistry.addSvgIcon(
    'close-icon',
    domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/close-icon.svg')
  );

  matIconRegistry.addSvgIcon(
    'microsoft-icon',
    domSanitizer.bypassSecurityTrustResourceUrl(
      '/assets/icons/microsoft-icon.svg'
    )
  );

  matIconRegistry.addSvgIcon(
    `bag-icon`,
    domSanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/bag-icon.svg`)
  );

  matIconRegistry.addSvgIcon(
    `box-icon`,
    domSanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/box-icon.svg`)
  );

  matIconRegistry.addSvgIcon(
    `box-filled-icon`,
    domSanitizer.bypassSecurityTrustResourceUrl(
      `/assets/icons/box-filled-icon.svg`
    )
  );

  matIconRegistry.addSvgIcon(
    `departments-menu-icon`,
    domSanitizer.bypassSecurityTrustResourceUrl(
      `/assets/icons/departments-menu-icon.svg`
    )
  );

  matIconRegistry.addSvgIcon(
    `tag-icon`,
    domSanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/tag-icon.svg`)
  );

  matIconRegistry.addSvgIcon(
    `user-settings-icon`,
    domSanitizer.bypassSecurityTrustResourceUrl(
      `/assets/icons/user-settings-icon.svg`
    )
  );

  matIconRegistry.addSvgIcon(
    `shop-icon`,
    domSanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/shop-icon.svg`)
  );

  matIconRegistry.addSvgIcon(
    `back-icon`,
    domSanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/back-icon.svg`)
  );

  matIconRegistry.addSvgIcon(
    `next-icon`,
    domSanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/next-icon.svg`)
  );

  matIconRegistry.addSvgIcon(
    'user-icon',
    domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/user-icon.svg')
  );

  matIconRegistry.addSvgIcon(
    'key-icon',
    domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/key-icon.svg')
  );

  matIconRegistry.addSvgIcon(
    'search-icon',
    domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/search-icon.svg')
  );

  matIconRegistry.addSvgIcon(
    'recent-icon',
    domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/recent-icon.svg')
  );
  matIconRegistry.addSvgIcon(
    'search-recent-icon',
    domSanitizer.bypassSecurityTrustResourceUrl(
      '/assets/icons/search-recent-icon.svg'
    )
  );
  matIconRegistry.addSvgIcon(
    'bringliesel-icon',
    domSanitizer.bypassSecurityTrustResourceUrl(
      '/assets/icons/bringliesel-icon.svg'
    )
  );
  matIconRegistry.addSvgIcon(
    'blocked-icon',
    domSanitizer.bypassSecurityTrustResourceUrl(
      '/assets/icons/blocked-icon.svg'
    )
  );
  matIconRegistry.addSvgIcon(
    'error-icon',
    domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/error-icon.svg')
  );
  matIconRegistry.addSvgIcon(
    'heart-icon',
    domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/heart-icon.svg')
  );

  matIconRegistry.addSvgIcon(
    'trash-icon',
    domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/trash-icon.svg')
  );
  matIconRegistry.addSvgIcon(
    'add-B2B',
    domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/add-B2B.svg')
  );

  matIconRegistry.addSvgIcon(
    'settings-icon',
    domSanitizer.bypassSecurityTrustResourceUrl(
      '/assets/icons/settings-icon.svg'
    )
  );

  matIconRegistry.addSvgIcon(
    'download-icon',
    domSanitizer.bypassSecurityTrustResourceUrl(
      '/assets/icons/download-icon.svg'
    )
  );

  matIconRegistry.addSvgIcon(
    'download-icon-cropped',
    domSanitizer.bypassSecurityTrustResourceUrl(
      '/assets/icons/download-icon-cropped.svg'
    )
  );

  matIconRegistry.addSvgIcon(
    'add-resident-icon',
    domSanitizer.bypassSecurityTrustResourceUrl(
      '/assets/icons/add-resident-icon.svg'
    )
  );

  matIconRegistry.addSvgIcon(
    'edit-icon',
    domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/edit-icon.svg')
  );

  matIconRegistry.addSvgIcon(
    'arrow-icon',
    domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/arrow-icon.svg')
  );
  matIconRegistry.addSvgIcon(
    'add-icon',
    domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/add-icon.svg')
  );
  matIconRegistry.addSvgIcon(
    'undo-icon',
    domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/undo-icon.svg')
  );
  matIconRegistry.addSvgIcon(
    'help-icon',
    domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/help-icon.svg')
  );

  matIconRegistry.addSvgIcon(
    'pin',
    domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/pin.svg')
  );

  matIconRegistry.addSvgIcon(
    'add-photo-icon',
    domSanitizer.bypassSecurityTrustResourceUrl(
      '/assets/icons/add-photo-icon.svg'
    )
  );
  matIconRegistry.addSvgIcon(
    'palette-icon',
    domSanitizer.bypassSecurityTrustResourceUrl(
      '/assets/icons/palette-icon.svg'
    )
  );

  matIconRegistry.addSvgIcon(
    'customer-change-icon',
    domSanitizer.bypassSecurityTrustResourceUrl(
      '/assets/icons/customer-change-icon.svg'
    )
  );

  matIconRegistry.addSvgIcon(
    'burger-icon',
    domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/burger-icon.svg')
  );
  matIconRegistry.addSvgIcon(
    'rectangle-portrait',
    domSanitizer.bypassSecurityTrustResourceUrl(
      '/assets/icons/rectangle-portrait.svg'
    )
  );
  matIconRegistry.addSvgIcon(
    'rectangle-landscape',
    domSanitizer.bypassSecurityTrustResourceUrl(
      '/assets/icons/rectangle-landscape.svg'
    )
  );

  matIconRegistry.addSvgIcon(
    'add-department-icon',
    domSanitizer.bypassSecurityTrustResourceUrl(
      '/assets/icons/add-department-icon.svg'
    )
  );

  matIconRegistry.addSvgIcon(
    'logout-icon',
    domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/logout-icon.svg')
  );
  matIconRegistry.addSvgIcon(
    'customer-icon',
    domSanitizer.bypassSecurityTrustResourceUrl(
      '/assets/icons/customer-icon.svg'
    )
  );

  matIconRegistry.addSvgIcon(
    'resident-icon',
    domSanitizer.bypassSecurityTrustResourceUrl(
      '/assets/icons/resident-icon.svg'
    )
  );
  matIconRegistry.addSvgIcon(
    'category-title-bg-icon',
    domSanitizer.bypassSecurityTrustResourceUrl(
      '/assets/icons/category-title-bg-icon.svg'
    )
  );

  matIconRegistry.addSvgIcon(
    'plus-icon',
    domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/plus-icon.svg')
  );

  matIconRegistry.addSvgIcon(
    'minus-icon',
    domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/minus-icon.svg')
  );

  matIconRegistry.addSvgIcon(
    'add-to-bag-icon',
    domSanitizer.bypassSecurityTrustResourceUrl(
      '/assets/icons/add-to-bag-icon.svg'
    )
  );

  matIconRegistry.addSvgIcon(
    'logo-beta',
    domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/logo-beta.svg')
  );

  matIconRegistry.addSvgIcon(
    'info-icon',
    domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/info-icon.svg')
  );
  matIconRegistry.addSvgIcon(
    'order-icon',
    domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/order-icon.svg')
  );
  matIconRegistry.addSvgIcon(
    'department_icon',
    domSanitizer.bypassSecurityTrustResourceUrl(
      '/assets/icons/department_icon.svg'
    )
  );
  matIconRegistry.addSvgIcon(
    'download-all-horizontal-icon',
    domSanitizer.bypassSecurityTrustResourceUrl(
      '/assets/icons/download-all-horizontal-icon.svg'
    )
  );
  matIconRegistry.addSvgIcon(
    'download-all-vertical-icon',
    domSanitizer.bypassSecurityTrustResourceUrl(
      '/assets/icons/download-all-vertical-icon.svg'
    )
  );
  matIconRegistry.addSvgIcon(
    'download-blank-horizontal-icon',
    domSanitizer.bypassSecurityTrustResourceUrl(
      '/assets/icons/download-blank-horizontal-icon.svg'
    )
  );
  matIconRegistry.addSvgIcon(
    'download-blank-vertical-icon',
    domSanitizer.bypassSecurityTrustResourceUrl(
      '/assets/icons/download-blank-vertical-icon.svg'
    )
  );
  matIconRegistry.addSvgIcon(
    'download-single-horizontal-icon',
    domSanitizer.bypassSecurityTrustResourceUrl(
      '/assets/icons/download-single-horizontal-icon.svg'
    )
  );
  matIconRegistry.addSvgIcon(
    'download-single-vertical-icon',
    domSanitizer.bypassSecurityTrustResourceUrl(
      '/assets/icons/download-single-vertical-icon.svg'
    )
  );
  matIconRegistry.addSvgIcon(
    'packaging-icon',
    domSanitizer.bypassSecurityTrustResourceUrl(
      '/assets/icons/packaging-icon.svg'
    )
  );
  matIconRegistry.addSvgIcon(
    'first-login-arrow-icon',
    domSanitizer.bypassSecurityTrustResourceUrl(
      '/assets/icons/first-login-arrow-icon.svg'
    )
  );
  matIconRegistry.addSvgIcon(
    'arrow_short',
    domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/arrow_short.svg')
  );
  matIconRegistry.addSvgIcon(
    'favourites-header-icon',
    domSanitizer.bypassSecurityTrustResourceUrl(
      '/assets/icons/favourites-header-icon.svg'
    )
  );
  matIconRegistry.addSvgIcon(
    'search-header-icon',
    domSanitizer.bypassSecurityTrustResourceUrl(
      '/assets/icons/search-header-icon.svg'
    )
  );
  matIconRegistry.addSvgIcon(
    'last-ordered-header-icon',
    domSanitizer.bypassSecurityTrustResourceUrl(
      '/assets/icons/last-ordered-header-icon.svg'
    )
  );
  matIconRegistry.addSvgIcon(
    'exclamation',
    domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/exclamation.svg')
  );
  matIconRegistry.addSvgIcon(
    'plus',
    domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/plus.svg')
  );
  matIconRegistry.addSvgIcon(
    'play-button-icon',
    domSanitizer.bypassSecurityTrustResourceUrl(
      '/assets/icons/play-button-icon.svg'
    )
  );
  matIconRegistry.addSvgIcon(
    'customer-selection-arrow-icon',
    domSanitizer.bypassSecurityTrustResourceUrl(
      '/assets/icons/customer-selection-arrow-icon.svg'
    )
  );
  matIconRegistry.addSvgIcon(
    'grid-icon',
    domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/grid-icon.svg')
  );
  matIconRegistry.addSvgIcon(
    'list-icon',
    domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/list-icon.svg')
  );
  matIconRegistry.addSvgIcon(
    'arrow-circle-right-icon',
    domSanitizer.bypassSecurityTrustResourceUrl(
      '/assets/icons/arrow-circle-right-icon.svg'
    )
  );
  matIconRegistry.addSvgIcon(
    'add-resident-dropdown-icon',
    domSanitizer.bypassSecurityTrustResourceUrl(
      '/assets/icons/add-resident-dropdown-icon.svg'
    )
  );
  matIconRegistry.addSvgIcon(
    'list-of-needs-icon',
    domSanitizer.bypassSecurityTrustResourceUrl(
      '/assets/icons/list-of-needs-icon.svg'
    )
  );
  matIconRegistry.addSvgIcon(
    'cursor-icon',
    domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/cursor-icon.svg')
  );
  matIconRegistry.addSvgIcon(
    'bedarfsliste-icon',
    domSanitizer.bypassSecurityTrustResourceUrl(
      '/assets/icons/bedarfsliste-icon.svg'
    )
  );
  matIconRegistry.addSvgIcon(
    'note-icon',
    domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/note-icon.svg')
  );
  matIconRegistry.addSvgIcon(
    'printer-icon',
    domSanitizer.bypassSecurityTrustResourceUrl(
      '/assets/icons/printer-icon.svg'
    )
  );
  matIconRegistry.addSvgIcon(
    'download-single-pdf-icon',
    domSanitizer.bypassSecurityTrustResourceUrl(
      '/assets/icons/download-single-pdf-icon.svg'
    )
  );
  matIconRegistry.addSvgIcon(
    'download-zip-icon',
    domSanitizer.bypassSecurityTrustResourceUrl(
      '/assets/icons/download-zip-icon.svg'
    )
  );
};

export const addClass = (elementId: string, className: string) => {
  const element = document.getElementById(elementId);
  if (element) {
    element.classList.add(className);
  }
};
export const removeClass = (elementId: string, className: string) => {
  const element = document.getElementById(elementId);
  if (element) {
    element.classList.remove(className);
  }
};

export const getPropertiesOnly = <T>(obj) => {
  return Object.keys(obj).reduce((props, key) => {
    if (typeof obj[key] !== 'function') {
      props[key] = obj[key];
    }
    return props;
  }, {} as T);
};

export const sortResidents = (residents: Resident[]): Resident[] => {
  return residents.sort((a, b) => {
    if (a.roomNumber === '' && b.roomNumber === '') {
      return a.lname.localeCompare(b.lname);
    }
    if (a.roomNumber === '') {
      return 1;
    }
    if (b.roomNumber === '') {
      return -1;
    }
    if (a.roomNumber === b.roomNumber) {
      return a.lname.localeCompare(b.lname);
    }
    return Number(a.roomNumber) - Number(b.roomNumber);
  });
};

async function httpRequest(url, options = {}) {
  try {
    const response = await fetch(url, options);

    // Handle global errors like 401
    if (response.status === 401) {
      return; // Stop further processing
    }

    // Check for other error statuses
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'An error occurred');
    }

    return await response.json(); // Return response data for successful requests
  } catch (error) {
    console.error('HTTP Error:', error.message);
    throw error; // Propagate error for request-specific handling
  }
}

export function sortBySortiment(
  a: Product | CartProduct,
  b: Product | CartProduct
) {
  const categorySortA =
    a.categories.length > 0 ? a.categories[0].categorySort : Infinity;
  const categorySortB =
    b.categories.length > 0 ? b.categories[0].categorySort : Infinity;

  if (categorySortA === 0 && categorySortB !== 0) return -1;
  if (categorySortA !== 0 && categorySortB === 0) return 1;

  if (categorySortA !== categorySortB) {
    return categorySortA - categorySortB;
  }

  const productSortA = a.sort !== undefined ? a.sort : Infinity;
  const productSortB = b.sort !== undefined ? b.sort : Infinity;

  if (productSortA === 0 && productSortB !== 0) return -1;
  if (productSortA !== 0 && productSortB === 0) return 1;

  return productSortA - productSortB;
}
